/* Généré par tools/build-invite-links.py — NE PAS ÉDITER À LA MAIN.
   Source : Member Einladung.xlsx · 2026-08-07
   Clé pays = la valeur postée par le <select> Shopify. */
window.MEMBER_INVITE_LINKS = {
 "argentina": {
  "land": "Argentinien",
  "sprachen": {
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/4vXU0i"
   }
  },
  "value": "Argentina"
 },
 "australia": {
  "land": "Australien",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/rdyBzL"
   }
  },
  "value": "Australia"
 },
 "austria": {
  "land": "Österreich",
  "sprachen": {
   "deutsch": {
    "label": "Deutsch",
    "link": "https://nskn.co/LqpcSp"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/0iR5LM"
   }
  },
  "value": "Austria"
 },
 "belgium": {
  "land": "Belgien",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/tfsEEh"
   },
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/qmWzsU"
   },
   "niederlandisch": {
    "label": "Nederlands",
    "link": "https://nskn.co/TJ3qVw"
   }
  },
  "value": "Belgium"
 },
 "canada": {
  "land": "Kanada",
  "sprachen": {
   "chinesisch": {
    "label": "中文",
    "link": "https://nskn.co/b4BikI"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/44EkR6"
   },
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/GKNWB5"
   }
  },
  "value": "Canada"
 },
 "chile": {
  "land": "Chile",
  "sprachen": {
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/xUAOkw"
   }
  },
  "value": "Chile"
 },
 "colombia": {
  "land": "Kolumbien",
  "sprachen": {
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/3zdLl2"
   }
  },
  "value": "Colombia"
 },
 "czech-republic": {
  "land": "Tschechische Republik",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/OMaRta"
   },
   "tschechisch": {
    "label": "Čeština",
    "link": "https://nskn.co/K82paM"
   }
  },
  "value": "Czech Republic"
 },
 "denmark": {
  "land": "Dänemark",
  "sprachen": {
   "danisch": {
    "label": "Dansk",
    "link": "https://nskn.co/q3DeWy"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/PKHq9Y"
   }
  },
  "value": "Denmark"
 },
 "finland": {
  "land": "Finnland",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/44SZUH"
   },
   "finnisch": {
    "label": "Suomi",
    "link": "https://nskn.co/LIIDY9"
   },
   "schwedisch": {
    "label": "Svenska",
    "link": "https://nskn.co/Y3v4AV"
   }
  },
  "value": "Finland"
 },
 "france": {
  "land": "Frankreich",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/RRj9jS"
   },
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/cMphll"
   }
  },
  "value": "France"
 },
 "french-polynesia": {
  "land": "Französisch Polynesien",
  "sprachen": {
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/763EAY"
   }
  },
  "value": "French Polynesia"
 },
 "germany": {
  "land": "Deutschland",
  "sprachen": {
   "deutsch": {
    "label": "Deutsch",
    "link": "https://nskn.co/emsI0W"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/emsI0W"
   }
  },
  "value": "Germany"
 },
 "hong-kong-sar": {
  "land": "Hongkong",
  "sprachen": {
   "chinesisch": {
    "label": "中文",
    "link": "https://nskn.co/IBXSHx"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/QbHiL9"
   }
  },
  "value": "Hong Kong SAR"
 },
 "hungary": {
  "land": "Ungarn",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/KEQq0G"
   },
   "ungarisch": {
    "label": "Magyar",
    "link": "https://nskn.co/ffU0D9"
   }
  },
  "value": "Hungary"
 },
 "iceland": {
  "land": "Island",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/NBpb1F"
   },
   "islandisch": {
    "label": "Íslenska",
    "link": "https://nskn.co/Dxt45N"
   }
  },
  "value": "Iceland"
 },
 "indonesia": {
  "land": "Indonesien",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/0G2nnZ"
   },
   "indonesisch": {
    "label": "Bahasa Indonesia",
    "link": "https://nskn.co/iouf5D"
   }
  },
  "value": "Indonesia"
 },
 "ireland": {
  "land": "Irland",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/vZeVRI"
   }
  },
  "value": "Ireland"
 },
 "italy": {
  "land": "Italien",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/zbotgZ"
   },
   "italienisch": {
    "label": "Italiano",
    "link": "https://nskn.co/bAJtfb"
   }
  },
  "value": "Italy"
 },
 "japan": {
  "land": "Japan",
  "sprachen": {
   "japanisch": {
    "label": "日本語",
    "link": "https://nskn.co/QwxGX3"
   }
  },
  "value": "Japan"
 },
 "luxembourg": {
  "land": "Luxemburg",
  "sprachen": {
   "deutsch": {
    "label": "Deutsch",
    "link": "https://nskn.co/mRrQc5"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/GDezI3"
   },
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/oz4FtX"
   }
  },
  "value": "Luxembourg"
 },
 "malaysia": {
  "land": "Malaysia",
  "sprachen": {
   "chinesisch": {
    "label": "中文",
    "link": "https://nskn.co/wcgtiS"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/ggdowX"
   },
   "malay": {
    "label": "Bahasa Melayu",
    "link": "https://nskn.co/XgT7eM"
   }
  },
  "value": "Malaysia"
 },
 "mexico": {
  "land": "Mexico",
  "sprachen": {
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/BJ61Dy"
   }
  },
  "value": "Mexico"
 },
 "netherlands": {
  "land": "Niederlande",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/Om5id6"
   },
   "niederlandisch": {
    "label": "Nederlands",
    "link": "https://nskn.co/n2Pyj7"
   }
  },
  "value": "Netherlands"
 },
 "new-caledonia": {
  "land": "Neukaledonien",
  "sprachen": {
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/ypun4b"
   }
  },
  "value": "New Caledonia"
 },
 "new-zealand": {
  "land": "Neuseeland",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/C5iLWK"
   }
  },
  "value": "New Zealand"
 },
 "norway": {
  "land": "Norwegen",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/o0hDPH"
   },
   "norwegisch": {
    "label": "Norsk",
    "link": "https://nskn.co/1S1Lof"
   }
  },
  "value": "Norway"
 },
 "peru": {
  "land": "Peru",
  "sprachen": {
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/wAew1l"
   }
  },
  "value": "Peru"
 },
 "philippines": {
  "land": "Philippinen",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/FZYX45"
   }
  },
  "value": "Philippines"
 },
 "poland": {
  "land": "Polen",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/Q4p0eB"
   },
   "polnisch": {
    "label": "Polski",
    "link": "https://nskn.co/S9X0xs"
   }
  },
  "value": "Poland"
 },
 "portugal": {
  "land": "Portugal",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/LrdAxX"
   },
   "portugiesisch": {
    "label": "Português",
    "link": "https://nskn.co/LrdAxX"
   }
  },
  "value": "Portugal"
 },
 "romania": {
  "land": "Rumänien",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/aOQima"
   },
   "rumanisch": {
    "label": "Română",
    "link": "https://nskn.co/BvDjO8"
   }
  },
  "value": "Romania"
 },
 "singapore": {
  "land": "Singapur",
  "sprachen": {
   "chinesisch": {
    "label": "中文",
    "link": "https://nskn.co/J7n9YP"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/y8qev6"
   }
  },
  "value": "Singapore"
 },
 "slovakia": {
  "land": "Slowakei",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/Mk7uAQ"
   },
   "slowakisch": {
    "label": "Slovenčina",
    "link": "https://nskn.co/R9Ehf7"
   }
  },
  "value": "Slovakia"
 },
 "south-africa": {
  "land": "Südafrika",
  "sprachen": {
   "chinesisch": {
    "label": "中文",
    "link": "https://nskn.co/FYBPj7"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/eQPTuB"
   }
  },
  "value": "South Africa"
 },
 "spain": {
  "land": "Spanien",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/MQJIrQ"
   },
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/qdnNcS"
   }
  },
  "value": "Spain"
 },
 "sweden": {
  "land": "Schweden",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/cxELJf"
   },
   "schwedisch": {
    "label": "Svenska",
    "link": "https://nskn.co/1Z61zS"
   }
  },
  "value": "Sweden"
 },
 "switzerland": {
  "land": "Schweiz",
  "sprachen": {
   "deutsch": {
    "label": "Deutsch",
    "link": "https://nskn.co/ZTc6bF"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/CS83mg"
   },
   "franzosisch": {
    "label": "Français",
    "link": "https://nskn.co/fp54Zl"
   },
   "italienisch": {
    "label": "Italiano",
    "link": "https://nskn.co/MYB9NO"
   }
  },
  "value": "Switzerland"
 },
 "thailand": {
  "land": "Thailand",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/K82paM"
   },
   "thai": {
    "label": "ไทย",
    "link": "https://nskn.co/cJuwwy"
   }
  },
  "value": "Thailand"
 },
 "united-kingdom": {
  "land": "Vereinigtes Königreich",
  "sprachen": {
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/hLjSAq"
   }
  },
  "value": "United Kingdom"
 },
 "united-states": {
  "land": "Vereinigte Staaten von Amerika",
  "sprachen": {
   "chinesisch": {
    "label": "中文",
    "link": "https://nskn.co/idHSez"
   },
   "englisch": {
    "label": "English",
    "link": "https://nskn.co/Rstfiu"
   },
   "spanisch": {
    "label": "Español",
    "link": "https://nskn.co/DIqzbK"
   },
   "vietmanesisch": {
    "label": "Tiếng Việt",
    "link": "https://nskn.co/wCLQRV"
   }
  },
  "value": "United States"
 }
};
